import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promotional-code-fields"
// Fills the read-only "code" field from the selected promotional code in the dropdown.
export default class extends Controller {
  static targets = ["select", "code"];
  static values = { codes: Object };

  fillCode() {
    const id = this.selectTarget.value;
    this.codeTarget.value = id ? this.codesValue[id] || "" : "";
  }
}
